module.exports = __webpack_public_path__ + "img/centerCensus1.a5a20ba7.png";